import type {Transport} from 'src/internal/transport/types';

export default function listen<TData>(
  transport: Transport,
  callback: (event: MessageEvent<TData>) => void,
): {start: () => void; stop: () => void} {
  let isListening = true;
  transport.addEventListener('message', callback);

  return {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    start: () => {
      if (isListening) {
        return;
      }

      transport.addEventListener('message', callback);
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    stop: () => {
      transport.removeEventListener('message', callback);
      isListening = false;
    },
  };
}
